<div class="animated fadeIn rounded">
  <div class="card">
    <div class="card-header">
      <i class="fa fa-truck"></i> Envio a Domicilio
      <div class="card-header-actions btn-group">
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-4">
          <div class="container-fluid p-0">
            <form [formGroup]="searchForm" (ngSubmit)="handleSubmit()" #searchTemplateForm="ngForm">
              <label for="txtInvoiceNumber">Número de factura</label>
              <div class="form-group input-group">
                <input type="text" class="form-control" id="txtInvoiceNumber" formControlName="searchCriteria"
                  (keyup.enter)="searchTemplateForm.ngSubmit.emit()" mask="000-000-00-00000000" [showMaskTyped]="true">
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="submit"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="col-12" *ngIf="isTicketCreated">
          <div
            [ngClass]="{ 'card text-white bg-primary': !ticketHasErrors, 'card text-white bg-danger': ticketHasErrors }">
            <h3 class="text-center mt-2"><b>{{ ticketHasErrors ? 'Ticket no procesado' : 'Ticket No. ' + ticketNumber
                }}</b></h3>
            <p class="text-center m-2" *ngIf="!ticketHasErrors">Esta factura ya posee un ticket creado</p>
            <span *ngIf="ticketHasErrors">
              <p class="text-center m-2" *ngFor="let error of ticketErrors">{{ error }}</p>
            </span>
          </div>
        </div>
        <div class="col-12">
          <accordion [isAnimated]="true" [hidden]="isLoaded">
            <accordion-group [isOpen]="false">

              <span accordion-heading class="btn-link text-primary">
                <i class='fa fa-question-circle'></i> Por Favor ingrese un codigo de factura
              </span>

            </accordion-group>
          </accordion>

          <accordion [isAnimated]="true" [hidden]="!isLoaded">
            <accordion-group [isOpen]="true">
              <span accordion-heading>
                <i class='fa fa-users'></i> Informacion de Cliente
              </span>
              <div class="form-group row">
                <label class="col-md-2 col-form-label"><b>Cliente:</b></label>
                <div class="col-md-10">
                  <input type="text" disabled class="form-control" [value]="customerInfo">
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-2 col-form-label"><b>Tipo de Entrega:</b></label>
                <ng-select class="col-md-4 " name="deliveryType" [items]="ticketTypes" bindLabel="description"
                  [selectOnTab]="true" [(ngModel)]="selectedDeliveryType" [disabled]="isTicketCreated">

                </ng-select>
              </div>
              <div class="form-group row">
                <label class="col-md-2 col-form-label"><b>Requiere Instalación:</b></label>
                <ui-switch class="col-md-4 " size="small" name="isDelivery" [disabled]="isTicketCreated"
                  [(ngModel)]="requiredInstalation"></ui-switch>

              </div>
              <div class="form-group row" [hidden]="!selectedDeliveryType?.useDestinationBranch">
                <label class="col-md-2 col-form-label"><b>Tienda Destino:</b></label>
                <ng-select class="col-md-4 " name="deliveryType" [items]="branches.content" bindLabel="name"
                  [selectOnTab]="true" [(ngModel)]="selectedDestinationBranch" [disabled]="isTicketCreated"
                  required></ng-select>

              </div>

            </accordion-group>
            <accordion-group [isOpen]="true">
              <span accordion-heading>
                <i class='fa fa-archive'></i> Productos
              </span>
              <pos-table [data]="invoiceLines" [headers]="getInvoiceLineHeaders()" [itemsPerPage]="10"
                [pagination]="false" [disableHighlight]="true">
              </pos-table>
            </accordion-group>
            <accordion-group [isOpen]="true" [hidden]="isTicketCreated">
              <span accordion-heading>
                <i class='fa fa-document'></i> Archivos Adjuntos
              </span>
              <pos-attachments [useDeliveryFiles]="true" [useAccordion]="false"
                (changeFile)="onFilesChanged($event)"></pos-attachments>
            </accordion-group>

          </accordion>

          <div class="col-sm-12 mt-4 text-center">
            <button type="button" class="btn btn-outline-primary" *ngIf="!isTicketCreated"
              (click)="createTicket()">Generar ticket</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>